var _a;
import React from "react";
import { FormattedMessage } from "react-intl";
import { RegistrationConflict } from "./registrationConflict";
/** Contacts page of the Czech National ISBN and ISMN Agency, as given by RCK-1639. */
export var REGISTRATION_CONTACTS_URL = "https://info-recek.nkp.cz/uzitecne-kontakty/";
var MESSAGE_IDS = (_a = {},
    _a[RegistrationConflict.COMPANY_NUMBER_ALREADY_EXISTS] = "stripes-core.error.companyNumberAlreadyExists",
    _a[RegistrationConflict.TAX_NUMBER_ALREADY_EXISTS] = "stripes-core.error.taxNumberAlreadyExists",
    _a[RegistrationConflict.REGISTRATION_ALREADY_SUBMITTED] = "stripes-core.error.registrationAlreadySubmitted",
    _a);
/**
 * The error shown in the registration form when the server refused the registration with HTTP 409. A natural
 * person registering again is pointed to the agency's contacts page by a link (RCK-1639).
 */
export var RegistrationConflictMessage = function (_a) {
    var conflict = _a.conflict;
    return (React.createElement(FormattedMessage, { id: MESSAGE_IDS[conflict], values: {
            link: function (chunks) { return (React.createElement("a", { href: REGISTRATION_CONTACTS_URL, target: "_blank", rel: "noopener noreferrer" }, chunks)); },
        } }));
};
